import { AuditType } from 'app/types/User';
import React from 'react';

type Props = {
  field: string;
  // TODO : Audit type will be changed
  changes: Extract<AuditType['data'], object>;
};

export const AuditChange = ({ field, changes }: Props) => {
  //@ts-ignore
  let oldValue = changes[field]?.old;
  //@ts-ignore
  let newValue = changes[field]?.new;
  return (
    <div className="audit-change">
      <span className="field">{field}:</span>
      {oldValue && <s className="old">{oldValue}</s>}
      {newValue && <span className="new">{newValue}</span>}
    </div>
  );
};
